/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

// Get selected text
export const getSelectionText = async (): Promise<string> => {
    return Word.run<string>(async (context: Word.RequestContext): Promise<string> => {
        const range = context.document.getSelection();
        range.load('text');

        await context.sync();
        return range.text;
    });
};

// Set a comment on the selected content.
export const insertComment = async (text: string): Promise<void> => {
    return Word.run(async (context: Word.RequestContext): Promise<void> => {
        context.document.getSelection().insertComment(text);
    });
};

// Get document security properties
export const getDocumentSecurityLevel = async (): Promise<number> => {
    return Word.run(async (context: Word.RequestContext): Promise<number> => {
        const builtInProperties = context.document.properties;
        // load security property!
        builtInProperties.load('security');

        await context.sync();
        return builtInProperties.security;
    });
};
